<template>
    <inter-table
            :showFilters="true"
            :fields="fields"
            action="users/admin"
    >
        <template v-slot:cell(color)="data">
            <i v-bind:style="{color : `${data.item.color}`}"
               class="fi big flaticon-rounded-black-square-shape ml-2"></i>
        </template>

        <template v-slot:cell(name)="data">
            <div class="text-uppercase">{{data.item.name}}</div>
        </template>
        <template v-slot:cell(surname)="data">
            <div class="text-uppercase">{{data.item.surname}}</div>
        </template>

        <template v-slot:cell(action)="data">
            <div class="d-flex justify-content-end">
                <inter-table-button
                        icon="flaticon-edit"
                        @onClick="$emit('onEditItem', data.item)"
                >
                </inter-table-button>
                <inter-table-button
                        styleBtn="secondaryButton"
                        icon="flaticon-key"
                        :to-confirm="true"
                        @onClick="$emit('onResetPasswordItem', data.item)"
                >
                </inter-table-button>
            </div>
        </template>

    </inter-table>
</template>

<script>
    import InterTable from "../../../components/table/InterTable";
    import InterTableButton from "../../../components/table/InterTableButton";

    export default {
        name: "AdminTable",
        components: {InterTableButton, InterTable},
        data() {
            return {

                fields: [
                    {key: 'color', label: '', class: 'p-0 text-center'},
                    {key: 'surname', label: 'Cognome', class: 'text-left'},
                    {key: 'name', label: 'Nome', class: 'text-left'},
                    {key: 'email', label: 'Email', class: 'text-left'},
                    {key: 'action', label: ''},
                ]
            }
        },
    }
</script>

<style scoped>

</style>
